export enum ETenantType {
  DIVISION_LIST = 'DIVISION_LIST',
  SINGLE_COMPANY = 'SINGLE_COMPANY',
  COMPANY_LIST = 'COMPANY_LIST',
  ALL_COMPANIES = 'ALL_COMPANIES',
}
